// Global ResizeObserver Error Suppression
// Prevents harmless ResizeObserver loop errors from cluttering console
// These errors occur when UI components resize faster than ResizeObserver can report
// Common with modern UI libraries (shadcn/radix, charts, dynamic tables)

if (typeof window !== "undefined") {
  const resizeObserverErr = /(ResizeObserver loop limit exceeded|ResizeObserver loop completed with undelivered notifications)/;
  
  // Suppress console.error messages
  const consoleError = console.error.bind(console);
  console.error = (message, ...args) => {
    if (typeof message === 'string' && resizeObserverErr.test(message)) {
      return;
    }
    consoleError(message, ...args);
  };
  
  // Suppress window error events
  window.addEventListener('error', (event) => {
    if (resizeObserverErr.test(event.message || '')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return true;
    }
  });
  
  // Suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || event.reason?.toString() || '';
    if (resizeObserverErr.test(message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return true;
    }
  });
  
  // Override ResizeObserver to add error boundary
  if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          try {
            callback(entries, observer);
          } catch (error) {
            if (!resizeObserverErr.test(error.message)) {
              throw error;
            }
          }
        });
      }
    };
  }
}

export default {};
